<template>
  <div class="benefits">
    <h1 class="benefits_heading heading1" :class="{ 'benefits_heading__open': show }" @click="$emit('toggle')">
      {{ $t('Ваши преимущества') }}
    </h1>
    <TransitionExpand>
      <Component
        :is="currentBenefitComponent"
        v-show="show"
        :game="selectedGame"
        :cardType="cardType"
      ></Component>
    </TransitionExpand>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { PARTNERS } from '@/constants'
import TransitionExpand from '@/common/components/transitions/TransitionExpand'
import {
  BenefitsMtRu,
  BenefitsMtBy,
  BenefitsMkRu,
  BenefitsMkBy,
  BenefitsTbRu,
  BenefitsTbBy,
  // Tinkoff
  BenefitsMtRuTinkoff,
  BenefitsMkRuTinkoff,
  BenefitsTbRuTinkoff
} from './partials'

const BENEFIT_COMPONENTS = {
  mt: {
    [PARTNERS.ALFA]: BenefitsMtRu,
    [PARTNERS.ALFA_BY]: BenefitsMtBy,
    [PARTNERS.ALFABANK_BY]: BenefitsMtBy,
    [PARTNERS.TBANK]: BenefitsMtRuTinkoff
  },
  mk: {
    [PARTNERS.ALFA]: BenefitsMkRu,
    [PARTNERS.ALFA_BY]: BenefitsMkBy,
    [PARTNERS.ALFABANK_BY]: BenefitsMkBy,
    [PARTNERS.TBANK]: BenefitsMkRuTinkoff
  },
  tb: {
    [PARTNERS.ALFA]: BenefitsTbRu,
    [PARTNERS.ALFA_BY]: BenefitsTbBy,
    [PARTNERS.ALFABANK_BY]: BenefitsTbBy,
    [PARTNERS.TBANK]: BenefitsTbRuTinkoff
  }
}

@Component({
  components: {
    TransitionExpand,
    BenefitsMtRu,
    BenefitsMtBy,
    BenefitsMkRu,
    BenefitsMkBy,
    BenefitsTbRu,
    BenefitsTbBy
  }
})
class Benefits extends Vue {
  @Prop({ type: String, required: true }) selectedGame
  @Prop({ type: Boolean }) show
  @Prop({ type: String }) partner
  @Prop({ type: String }) cardType

  @State('country') currentCountry

  /**
   * dynamic child component
   * @returns {String}
   */
  get currentBenefitComponent () {
    return BENEFIT_COMPONENTS[this.selectedGame][this.partner]
  }
}

export default Benefits
</script>

<style lang="scss">
.benefits {
  @extend %layout;

  &_heading {
    cursor: pointer;
    margin-bottom: 16px;
    position: relative;
    @include media_tablet {
      margin-bottom: 28px;
    }
    @include media_desktop {
      margin-bottom: 18px;
    }

    &:after {
      content: "";
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid;
      display: inline-block;
      position: absolute;
      right: 0;
      top: 9px;
      vertical-align: middle;
      transition: transform $duration linear;
      @include media_tablet {
        position: static;
        margin-left: 20px;
      }
    }
    &__open:after {
      transform: rotate(180deg);
    }
  }
  &_holder {
    @include media_desktop {
      display: flex;
    }
  }
  &_item {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 14px;
    margin: 9px 0;
    position: relative;
    @include media_tablet {
      font-size: 18px;
      line-height: normal;
      margin: 2px 0;
    }
    @include media_desktop {
      font-size: 14px;
      line-height: 18px;
      margin-left: 60px;
      width: 250px;

      &:first-child {
        margin-left: 0;
      }
    }

    &:before {
      content: '';
      display: block;
      background: no-repeat 50% 50%;
      background-size: contain;
      flex-shrink: 0;
      height: 45px;
      width: 45px;
      margin-right: 22px;
      @include media_tablet {
        height: 80px;
        width: 80px;
        margin-right: 38px;
      }
      @include media_desktop {
        margin-right: 12px;
      }
    }
    $benefits: prem prem-mk prem-tb gold gold-tb dublons farm-gold farm-dublons reserves flags percent-bonus-tb;
    @each $item in $benefits {
      &__#{$item}:before {
        background-image: url("./images/#{$item}.webp");
      }
    }
  }
}
</style>
